import imageDe from '../images/de/uploader-ascensiaContour-problem-2.png';
import imageEn from '../images/en/uploader-ascensiaContour-problem-2.png';
import imageEs from '../images/es/uploader-ascensiaContour-problem-2.png';
import imageFi from '../images/fi/uploader-ascensiaContour-problem-2.png';
import imageFr from '../images/fr/uploader-ascensiaContour-problem-2.png';
import imageIt from '../images/it/uploader-ascensiaContour-problem-2.png';
import imageNo from '../images/no/uploader-ascensiaContour-problem-2.png';
import imageSv from '../images/sv/uploader-ascensiaContour-problem-2.png';

export const uploaderTryAgainImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
